<template>
  <span>
    <b-btn block variant="warning" class="font-weight-bold" @click="showModal">
      Tax Exemption
    </b-btn>
    <c-modal
      v-model="modal"
      cancel-label="Never mind"
      centered
      title="Tax Exemption"
      :tag="false"
      confirm-label="Apply Tax Exemption"
      :progressing="progressing"
      size="lg">
      <template>
        <div>
          Fill out the following fields to apply tax exemption to this tab.
        </div>
        <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
          <ul class="m-0 px-1">
            <li v-for="err in errors.all()" :key="err">{{err}}</li>
          </ul>
        </b-alert>
        <div>
          <b-input-group prepend="Tab Exemption Nubmer" class="my-3">
            <b-input type="text" v-model="ExemptionNo" class="myFeild" placeholder="Required" v-validate="'required'" name="Tab Exemption Nubmer"/>
          </b-input-group>

          <b-input-group prepend="Exempt Customer Name">
            <b-input type="text" v-model="ExemptionName" class="myFeild" placeholder="Required" v-validate="'required'" name="Exempt Customer Name"/>
          </b-input-group>
        </div>
      </template>
      <template #actions>
          <b-row class="flex-grow-1">
            <b-col :cols="order.ExemptionNo ? 4 : 6">
              <b-btn variant="warning" block class="text-nowrap" :disabled="progressing" @click="submit">
                Apply Tax Exemption
                <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
              </b-btn>
            </b-col>
            <b-col v-if="order.ExemptionNo" cols="4">
              <b-btn variant="danger" block class="text-nowrap" :disabled="progressing" @click="removeExemption">
                Remove Tax Exemption
                <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
              </b-btn>
            </b-col>
            <b-col :cols="order.ExemptionNo ? 4 : 6">
              <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="modal = false">
                Never mind
              </b-btn>
            </b-col>
          </b-row>
      </template>
    </c-modal>
  </span>
</template>

<script>
  import CModal from "./Cmodal";
  export default {
    name: "taxExemption",
    components: {CModal},
    props: {
      order: {
        required: true,
        type: Object
      }
    },
    data () {
      return {
        modal: false,
        progressing: false,
        ExemptionNo: '',
        ExemptionName: '',
      }
    },
    methods: {
      showModal () {
        this.ExemptionName = this.order.CustomerName === 'NO NAME' ? '' : this.order.CustomerName
        this.ExemptionNo = this.order.ExemptionNo
        this.modal = true
      },
      submit () {
        this.$validator.validateAll().then(proceed => {
          if (proceed) {
            const model = {
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem('userID'),
              OrderID: this.order.OrderID,
              ExemptionNo: this.ExemptionNo,
              ExemptionName: this.ExemptionName
            }
            this.progressing = true
            return this.$api.getRestaurant.UpdateOrderTaxExemption(model).then(res => {
              this.progressing = false
              if (res.success) {
                this.modal = false
                this.$emit('refresh')
              } else {
                this.$showError(res.message)
              }
            }).catch(() => {

            }).finaly(() => {
              this.progressing = false
            })
          }
        })
      },
      removeExemption () {
        const model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          // UserID: localStorage.getItem('userID'),
          OrderID: this.order.OrderID,
          ExemptionNo: '',
          ExemptionName: ''
        }
        this.progressing = true
        return this.$api.getRestaurant.UpdateOrderTaxExemption(model).then(res => {
          this.progressing = false
          if (res.success) {
            this.modal = false
            this.$emit('refresh')
          } else {
            this.$showError(res.message)
          }
        }).catch(() => {

        }).finaly(() => {
          this.progressing = false
        })
      }
    }
  }
</script>

<style scoped>

</style>
